import { render, staticRenderFns } from "./PopularityRank.vue?vue&type=template&id=6a2aeda0&scoped=true&"
import script from "./PopularityRank.vue?vue&type=script&lang=js&"
export * from "./PopularityRank.vue?vue&type=script&lang=js&"
import style0 from "./PopularityRank.vue?vue&type=style&index=0&id=6a2aeda0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2aeda0",
  null
  
)

export default component.exports